import useScript from '../useScript';

import "../Common.css"
import './SmallPlanets.css';

function SmallPlanets()
{
    useScript('../js/LegoPlanets/SmallPlanets.js');

    return (
        <div>
            <img id="Sun" src="../assets/LegoPlanets/arrows/Sun.png" width="20" alt=""/>
            <img id="Mercury" src="../assets/LegoPlanets/arrows/Mercury.png" width="20" alt=""/>
            <img id="Venus" src="../assets/LegoPlanets/arrows/Venus.png" width="20" alt=""/>
            <img id="Earth" src="../assets/LegoPlanets/arrows/Earth.png" width="20" alt=""/>
            <img id="Mars" src="../assets/LegoPlanets/arrows/Mars.png" width="20" alt=""/>
            <img id="Jupiter" src="../assets/LegoPlanets/arrows/Jupiter.png" width="20" alt=""/>
            <img id="Saturn" src="../assets/LegoPlanets/arrows/Saturn.png" width="20" alt=""/>
            <img id="Uranus" src="../assets/LegoPlanets/arrows/Uranus.png" width="20" alt=""/>
            <img id="Neptune" src="../assets/LegoPlanets/arrows/Neptune.png" width="20" alt=""/>

            <div id="smallPlanets"></div>
        </div>
    )
}

export default SmallPlanets;